import React from 'react';

import Icon from '../Icon';

export const VibrationIntensityMidIcon = (props) => {
    return (
        <Icon width='48' height='48' viewBox='0 0 32 32' fill='none' {...props}>
            <path
                d='M6.40041 13.1558H5.6893C5.49293 13.1558 5.33374 13.3149 5.33374 13.5113V18.4891C5.33374 18.6855 5.49293 18.8447 5.6893 18.8447H6.40041C6.59677 18.8447 6.75596 18.6855 6.75596 18.4891V13.5113C6.75596 13.3149 6.59677 13.1558 6.40041 13.1558Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M26.3115 13.1558H25.6004C25.4041 13.1558 25.2449 13.3149 25.2449 13.5113V18.4891C25.2449 18.6855 25.4041 18.8447 25.6004 18.8447H26.3115C26.5079 18.8447 26.6671 18.6855 26.6671 18.4891V13.5113C26.6671 13.3149 26.5079 13.1558 26.3115 13.1558Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M11.3782 9.95557H10.6671C10.4707 9.95557 10.3115 10.1148 10.3115 10.3111V21.6889C10.3115 21.8853 10.4707 22.0445 10.6671 22.0445H11.3782C11.5746 22.0445 11.7337 21.8853 11.7337 21.6889V10.3111C11.7337 10.1148 11.5746 9.95557 11.3782 9.95557Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M21.3338 9.95557H20.6226C20.4263 9.95557 20.2671 10.1148 20.2671 10.3111V21.6889C20.2671 21.8853 20.4263 22.0445 20.6226 22.0445H21.3338C21.5301 22.0445 21.6893 21.8853 21.6893 21.6889V10.3111C21.6893 10.1148 21.5301 9.95557 21.3338 9.95557Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M16.356 5.3335H15.6449C15.4485 5.3335 15.2893 5.49268 15.2893 5.68905V26.3113C15.2893 26.5076 15.4485 26.6668 15.6449 26.6668H16.356C16.5523 26.6668 16.7115 26.5076 16.7115 26.3113V5.68905C16.7115 5.49268 16.5523 5.3335 16.356 5.3335Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
        </Icon>
    );
};
